import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import { ReportFormats } from '../utils';
import styles from './SidePanel.module.less';
import type { ReportFormat } from '../../../../../types';
import ReportListElement from './ReportListElement';

/**
 * Provides the report format selection menu
 */
const ReportFormatSelection = () => {
  const dispatch = useDispatch();
  const category = useSelector(ReportGenerationStore.selectors.getCategory);
  const availableFormats = useSelector(ReportGenerationStore.selectors.getAvailableFormats);
  const format = useSelector(ReportGenerationStore.selectors.getFormat);

  // Only update when category changes
  useEffect(() => {
    const defaultFormat = availableFormats[0]?.key || ReportFormats.HTML;
    dispatch(ReportGenerationStore.actions.setFormat(defaultFormat));
  }, [category, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelectFormat = (key: string) =>
    dispatch(ReportGenerationStore.actions.setFormat(key as ReportFormat));

  return (
    <div className={cx(styles.reportFormatSelection)}>
      <div className="panel-heading text-center">
        Select Report Format
      </div>
      <ul className="nav nav-minimal nav-stacked">
        {availableFormats.map(({ key, name, icon }) =>
          <ReportListElement
            id={key}
            name={name}
            icon={icon}
            isActive={format === key}
            onSelect={onSelectFormat}
          />,
        )}
      </ul>
    </div>
  );
};

export default ReportFormatSelection;
